import { toCurrency } from '@/shared/helpers';

// The API sends dates preformatted as "MM/DD/YYYY hh:mm AM TZ" in the billing
// timezone, which react-table's default text sort orders by month first.
// Anything that isn't a date ("After review") sorts after every date.
const sortableTime = (value) => {
  const match = /^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2}) (AM|PM)/.exec(value ?? '');
  if (!match) {
    return Infinity;
  }
  const [, month, day, year, hour, minute, meridiem] = match;
  const hour24 = (Number(hour) % 12) + (meridiem === 'PM' ? 12 : 0);
  return Date.UTC(year, month - 1, day, hour24, minute);
};

const byDisplayedTime = (rowA, rowB, columnId) => {
  const a = sortableTime(rowA.values[columnId]);
  const b = sortableTime(rowB.values[columnId]);
  return a === b ? 0 : a > b ? 1 : -1;
};

export const PENDING_HOLDS_COLUMNS = [
  {
    Header: 'Organization',
    accessor: 'organization_name',
  },
  {
    Header: 'Program',
    accessor: 'program_name',
  },
  {
    Header: 'Hold Type',
    accessor: 'hold_type',
  },
  {
    Header: 'Reason',
    accessor: 'reason',
  },
  {
    Header: 'Amount',
    accessor: 'amount',
    Cell: ({ value }) => toCurrency(value),
    sortType: 'basic',
  },
  {
    Header: 'Hold Started',
    accessor: 'hold_started',
    sortType: byDisplayedTime,
  },
  {
    Header: 'Scheduled Release',
    accessor: 'scheduled_release',
    sortType: byDisplayedTime,
  },
  {
    Header: 'Status',
    accessor: 'status',
  },
];
